





const Footer = () => {
    return (
        <div className="footer">
            <p>Copyright {new Date().getFullYear()}. All Rights Reserved</p>
        </div>
    )
}

export default Footer 